// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hariyama: PokeData = {
  "id": 297,
  "name": "hariyama",
  "height": 23,
  "weight": 2538,
  "base_experience": 166,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "whirlwind",
    "sand-attack",
    "tackle",
    "seismic-toss",
    "focus-energy",
    "reversal",
    "belly-drum",
    "detect",
    "endure",
    "vital-throw",
    "fake-out",
    "focus-punch",
    "smelling-salts",
    "knock-off",
    "arm-thrust",
    "bulk-up",
    "wake-up-slap",
    "brine",
    "close-combat",
    "force-palm",
    "heavy-slam",
    "headlong-rush"
  ],
  "moves": [
    "tackle",
    "seismic-toss",
    "bulk-up",
    "brine",
    "close-combat",
    "drain-punch",
    "superpower",
    "meteor-assault",
    "rolling-kick",
    "karate-chop",
    "double-kick",
    "coaching",
    "jump-kick"
  ],
  "evolution_chain": {
    "id": 146,
    "item": null,
    "species": [
      {
        "name": "makuhita",
        "order": 322,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "hariyama",
        "order": 323,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 296,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 150,
    "speed": 74,
    "ability_power": 176
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
